import { ScreenOrientation } from '@capacitor/screen-orientation'

export const lockPortraitOrientation = async () => {
  await ScreenOrientation.lock({ orientation: 'portrait' })
}

export const lockLandscapeOrientation = async () => {
  await ScreenOrientation.lock({ orientation: 'landscape' })
}

export const unlockOrientation = async () => {
  await ScreenOrientation.unlock()
}

export const addEventListeners = () => {
  const iframe = document.querySelector('iframe')
  if (iframe === null) {
    return
  }

  iframe.addEventListener('fullscreenchange', handleFullscreenChange)
  iframe.addEventListener('mozfullscreenchange', handleFullscreenChange)
  iframe.addEventListener('webkitfullscreenchange', handleFullscreenChange)
}

export const removeEventListeners = async () => {
  const iframe = document.querySelector('iframe')
  if (iframe === null) {
    return
  }

  iframe.removeEventListener('fullscreenchange', handleFullscreenChange)
  iframe.removeEventListener('mozfullscreenchange', handleFullscreenChange)
  iframe.removeEventListener('webkitfullscreenchange', handleFullscreenChange)
  await ScreenOrientation.lock({ orientation: 'portrait' })
}

const handleFullscreenChange = async () => {
  const isVideoFullscreen = !!document.fullscreenElement

  if (isVideoFullscreen && isVideoFullscreen === true) {
    unlockOrientation()
  } else {
    lockPortraitOrientation()
  }
}
